"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var Subject_1 = require("rxjs/Subject");
var form_model_1 = require("../../model/form.model");
var operators_1 = require("rxjs/operators");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var form_dialog_type_enum_1 = require("./form-dialog-type-enum");
var FormDialogComponent = /** @class */ (function () {
    function FormDialogComponent(messageService, kbService, languageService, dialogRef, data) {
        this.messageService = messageService;
        this.kbService = kbService;
        this.languageService = languageService;
        this.dialogRef = dialogRef;
        this.initialized = false;
        this.validations = new Map();
        this.changedCategory = new Subject_1.Subject();
        this.destroy$ = new Subject_1.Subject();
        this.currentLanguageId = data.currentLanguageId;
        this.formType = data.formType;
        this.headerKey = data.headerKey;
    }
    FormDialogComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
    };
    FormDialogComponent.prototype.ngOnInit = function () {
        this.languages$ = this.initAvailableLanguages();
        this.inputLanguages$ = this.initInputLanguages();
        this.formCategories$ = this.loadFormCategories();
        if (this.formType !== form_dialog_type_enum_1.FormDialogTypeEnum.WORKFLOW_FORM) {
            this.formTypes$ = this.loadFormTypes();
        }
        this.form$ = this.initForm();
        if (this.formType === form_dialog_type_enum_1.FormDialogTypeEnum.SUB_ENTITY_FORM) {
            this.loadSubEntity();
        }
    };
    FormDialogComponent.prototype.addAction = function (form) {
        var _this = this;
        this.validate(form).pipe(operators_1.take(1)).subscribe(function (invalidFields) {
            _this.validations = invalidFields;
            if (_this.validations.size === 0) {
                form.systemName = form.categorySystemName + (form.typeId == 1 ? 'View' : 'Edit');
                _this.dialogRef.close(form);
            }
        });
    };
    FormDialogComponent.prototype.cancelAction = function () {
        this.dialogRef.close();
    };
    FormDialogComponent.prototype.changeAction = function (mainCategorySystemName) {
        this.changedCategory.next(mainCategorySystemName);
    };
    FormDialogComponent.prototype.loadSubEntity = function () {
        var _this = this;
        this.changedCategory
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (categorySystemName) {
            _this.formSubEntities = [];
            if (categorySystemName) {
                _this.loadSubEntityBySystemName(categorySystemName);
            }
        });
    };
    FormDialogComponent.prototype.initInputLanguages = function () {
        return this.languageService.getInputLanguages()
            .pipe(operators_1.publishReplay(1), operators_1.refCount());
    };
    FormDialogComponent.prototype.initAvailableLanguages = function () {
        return this.languageService.getAvailableLanguages()
            .pipe(operators_1.publishReplay(1), operators_1.refCount());
    };
    FormDialogComponent.prototype.loadSubEntityBySystemName = function (categorySystemName) {
        var _this = this;
        if (categorySystemName) {
            this.kbService.getMetaFields(categorySystemName)
                .pipe(operators_1.takeUntil(this.destroy$), operators_1.mergeMap(function (metaFields) {
                return metaFields.map(function (metaField) {
                    if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                        var category = new idm_kb_service_client_js_1.MetaCategoryId(metaField.getCompoundCategorySystemName());
                        _this.kbService.getMetaCategoryByMetaCategoryId(category).subscribe(function (metaCategory) {
                            _this.formSubEntities.push(metaCategory);
                            _this.loadSubEntityBySystemName(metaField.getSystemName());
                        });
                    }
                });
            }))
                .subscribe();
        }
    };
    FormDialogComponent.prototype.loadFormCategories = function () {
        return this.kbService.getMainEntityMetaCategories()
            .pipe(operators_1.map(function (metaCategories) { return Array.from(metaCategories); }), operators_1.publishReplay(1), operators_1.refCount());
    };
    FormDialogComponent.prototype.loadFormTypes = function () {
        return combineLatest_1.combineLatest(this.initFormType(1, 'cs_view'), this.initFormType(2, 'cs_edit')).pipe(operators_1.publishReplay(1), operators_1.refCount());
    };
    FormDialogComponent.prototype.initFormType = function (id, messageKey) {
        var propertiesBuilder = new idm_de_core_frontend_1.ValueAccessorPropertiesBuilder();
        return this.messageService.getMessage(messageKey).pipe(operators_1.map(function (message) {
            propertiesBuilder.withNameForValue('id', id);
            propertiesBuilder.withNameForValue('name', message);
            return new idm_classifier_service_client_js_1.ClassifierView(propertiesBuilder.buildMap());
        }));
    };
    FormDialogComponent.prototype.initForm = function () {
        var _this = this;
        return this.languages$.pipe(operators_1.map(function (languages) { return _this.createForm(languages); }), operators_1.publishReplay(1), operators_1.refCount());
    };
    FormDialogComponent.prototype.createForm = function (languages) {
        var values = new Map();
        languages.forEach(function (language) {
            values.set(language.getId(), null);
        });
        var dummyName = new idm_crosscutting_concepts_frontend_1.MultilingualString(values);
        var dummyDescription = new idm_crosscutting_concepts_frontend_1.MultilingualString(values);
        return new form_model_1.Form(null, null, null, this.formType !== form_dialog_type_enum_1.FormDialogTypeEnum.WORKFLOW_FORM ? 1 : 2, dummyName, dummyDescription, '', null, this.formType);
    };
    FormDialogComponent.prototype.validate = function (form) {
        var _this = this;
        return this.inputLanguages$.pipe(operators_1.map(function (languages) { return _this.validateFields(languages, form); }));
    };
    FormDialogComponent.prototype.validateFields = function (languages, form) {
        var invalidFields = new Map();
        this.validations.clear();
        if (form.categorySystemName === null) {
            invalidFields.set('categorySystemName', true);
        }
        if (this.formType === form_dialog_type_enum_1.FormDialogTypeEnum.SUB_ENTITY_FORM && form.subCategorySystemName === null) {
            invalidFields.set('subCategorySystemName', true);
        }
        languages.forEach(function (language) {
            if (!form.name.getValue(language.getId()) || form.name.getValue(language.getId()).length === 0) {
                invalidFields.set('name', true);
            }
        });
        return invalidFields;
    };
    FormDialogComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    FormDialogComponent = __decorate([
        core_1.Component({
            
            selector: 'form-edit-component',
            template: require('./form.component.html'),
            styles: [require('./form.component.css')],
        }),
        __param(4, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.MessageService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            material_1.MatDialogRef, Object])
    ], FormDialogComponent);
    return FormDialogComponent;
}());
exports.FormDialogComponent = FormDialogComponent;
//# sourceMappingURL=form-dialog.component.js.map